import { GET_ARBEITSBEREICHE_BY_STANDORT_ID } from '@/domain/dienstplan/shared/hooks/useArbeitsbereiche/queries';
import {
  Arbeitsbereich,
  Mindestbelegung,
} from '@/domain/dienstplan/shared/types/Arbeitsbereich';
import { Weekday } from '@/domain/dienstplan/shared/types/Weekday';
import {
  Dienstplan_ArbeitsbereichByStandortIdQuery,
  Dienstplan_ArbeitsbereichByStandortIdQueryVariables,
  Dienstplan_Tag,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';

export function useArbeitsbereiche(standortId: string) {
  const result = useSuspenseQuery<
    Dienstplan_ArbeitsbereichByStandortIdQuery,
    Dienstplan_ArbeitsbereichByStandortIdQueryVariables
  >(GET_ARBEITSBEREICHE_BY_STANDORT_ID, {
    variables: {
      standortId: standortId,
    },
    fetchPolicy: 'no-cache',
  });

  if (result.error) {
    throw new Error(`Error fetching arbeitsbereiche: ${result.error.message}`);
  }
  const arbeitsbereiche: Arbeitsbereich[] =
    result.data.dienstplan_arbeitsbereich.map((ab) => {
      return {
        id: ab.id,
        name: ab.name,
        markierung: ab.markierung,
        mindestbelegungen: ab.mindestbelegung.map(
          (mb): Mindestbelegung => ({
            tag: mapTagToWeekday(mb.tag),
            einstellungen: {
              bemerkung: mb.einstellungen.bemerkung,
              maxAnzahlMitarbeiter: mb.einstellungen.maxAnzahlMitarbeiter,
              unbesetzteSchichten: mb.einstellungen.unbesetzteSchichten,
              zielumsatzproduktivitaet:
                mb.einstellungen.zielumsatzproduktivitaet,
              zielabsatzproduktivitaet: {
                mpt: mb.einstellungen.zielabsatzproduktivitaet.mpt,
                stueckzahl:
                  mb.einstellungen.zielabsatzproduktivitaet.stueckzahl,
              },
            },
          }),
        ),
      };
    });

  return arbeitsbereiche;
}

// eslint-disable-next-line complexity
function mapTagToWeekday(tag: Dienstplan_Tag): Weekday {
  if (tag === Dienstplan_Tag.Montag) {
    return 'montag';
  }
  if (tag === Dienstplan_Tag.Dienstag) {
    return 'dienstag';
  }
  if (tag === Dienstplan_Tag.Mittwoch) {
    return 'mittwoch';
  }
  if (tag === Dienstplan_Tag.Donnerstag) {
    return 'donnerstag';
  }
  if (tag === Dienstplan_Tag.Freitag) {
    return 'freitag';
  }
  if (tag === Dienstplan_Tag.Samstag) {
    return 'samstag';
  }
  if (tag === Dienstplan_Tag.Sonntag) {
    return 'sonntag';
  }
  return 'feiertag';
}
